// src/services/adminMarketplace.js
// Domaine Marketplace — façade Worker Admin → Worker Marketplace uniquement.

import { apiFetch, buildQuery } from './adminHttp';

/* ---------- Candidatures (Étape 3) ---------- */

/**
 * GET /admin/marketplace/applications — MARKETPLACE_VOIR
 * Query : limit, cursor, status (optionnels)
 */
export async function getApplications(params = {}) {
  return apiFetch(`/admin/marketplace/applications${buildQuery(params)}`, {
    method: 'GET',
  });
}

/** GET /admin/marketplace/applications/:id — MARKETPLACE_VOIR */
export async function getApplication(id) {
  return apiFetch(`/admin/marketplace/applications/${encodeURIComponent(id)}`, {
    method: 'GET',
  });
}

/** POST /admin/marketplace/applications/:id/approve — MARKETPLACE_VENDEURS_MODIFIER */
export async function approveApplication(id) {
  return apiFetch(`/admin/marketplace/applications/${encodeURIComponent(id)}/approve`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/**
 * POST /admin/marketplace/applications/:id/reject — MARKETPLACE_VENDEURS_MODIFIER
 * Body exact : { reason }
 */
export async function rejectApplication(id, reason) {
  return apiFetch(`/admin/marketplace/applications/${encodeURIComponent(id)}/reject`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}
